import { atom } from "jotai";
import * as z from "zod";

import MessageDialog from "src/components/MessageDialog/MessageDialog";
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "src/components/ui/form";
import { Textarea } from "src/components/ui/textarea";
import { SEND_FEEDBACK_MUTATION } from "src/lib/queries/feedback";

export const feedbackDialogAtom = atom({
  open: false,
});

const formSchema = z.object({
  message: z.string().min(10, {
    message: "Feedback message must be at least 10 characters",
  }),
});

const FeedbackDialog = () => (
  <MessageDialog
    formSchema={formSchema}
    defaultValues={{ message: "" }}
    atom={feedbackDialogAtom}
    mutation={SEND_FEEDBACK_MUTATION}
    title="Feedback"
    infoBoxText={`Share feedback or ideas on how we can improve ${process.env.APP_NAME}`}
  >
    {({ form, loading, submitted }) => (
      <FormField
        control={form.control}
        name="message"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Your Feedback</FormLabel>
            <FormControl>
              <Textarea
                placeholder="Please share your feedback"
                className="min-h-[150px]"
                {...field}
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
        disabled={loading || submitted}
      />
    )}
  </MessageDialog>
);

export default FeedbackDialog;
